import React, { ReactNode, useState } from "react";
import { Product } from "../../context/product-context/product";
import { ProductFamily } from "../../context/product-context/product-family";
import { AdditionalInfoDialog } from "./cardholder-application/table/body/additional-info-dialog";
import { DashboardCardApplicationDocument } from "../../api/commercial/generated-types";

interface DashboardContextProps {
  appliedProducts: Product[];
  allProductsForFamily: Product[];
  children: ReactNode;
}

interface DashboardContextType {
  appliedProducts: Product[];
  allProductsForFamily: Product[];
  appliedFamilies: Set<ProductFamily>;
  onOpenAdditionalInfoDialog: (
    dashboardCardApplicationDocument: DashboardCardApplicationDocument,
  ) => void;
}

export const DashboardContext = React.createContext<DashboardContextType>({
  appliedProducts: [],
  allProductsForFamily: [],
  appliedFamilies: new Set(),
  onOpenAdditionalInfoDialog: undefined,
});

const DashboardContextProvider = ({
  appliedProducts,
  allProductsForFamily,
  children,
}: DashboardContextProps): React.JSX.Element => {
  const [additionalInfoDialogActive, setAdditionalInfoDialogActive] =
    useState(false);
  const [additionalInfoCardApplication, setAdditionalInfoCardApplication] =
    useState<DashboardCardApplicationDocument>(null);

  const onOpenAdditionalInfoDialog: DashboardContextType["onOpenAdditionalInfoDialog"] =
    (
      dashboardCardApplicationDocument: DashboardCardApplicationDocument,
    ): void => {
      setAdditionalInfoDialogActive(true);
      setAdditionalInfoCardApplication(dashboardCardApplicationDocument);
    };

  let appliedFamiliesDistinct: Set<ProductFamily> = new Set();
  if (appliedProducts.length > 0) {
    appliedFamiliesDistinct = new Set(
      appliedProducts.map((product) => {
        return product.family;
      }),
    );
  }

  return (
    <DashboardContext.Provider
      value={{
        appliedProducts,
        allProductsForFamily,
        appliedFamilies: appliedFamiliesDistinct,
        onOpenAdditionalInfoDialog,
      }}
    >
      {additionalInfoDialogActive && (
        <AdditionalInfoDialog cardApplication={additionalInfoCardApplication} />
      )}
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardContextProvider;
